import {Buffer} from "buffer"
const posicion1 = window.location.href.indexOf(':')
const posicion2 = window.location.href.lastIndexOf(':')
const posicion3 = window.location.href.indexOf('/',posicion1+3)
export default{
  //URL_ACCESO_GENERAL: 'https://192.168.1.212:5001/api',

  URL_ACCESO_GENERAL: 'https:' + window.location.href.substring(posicion1+1, 
  posicion1 < posicion2
    ? posicion2 : posicion3 )+ ':5001/api',

  URL_API: 
    Buffer.from(window.localStorage.getItem(`CadenaBack_${window.sessionStorage.Centro}`) 
      ? window.localStorage.getItem(`CadenaBack_${window.sessionStorage.Centro}`)+'' 
      : '' , "base64").toString() ,

  Authorization: 'Bearer '+window.localStorage.getItem(`Token_${window.sessionStorage.Centro}`)
  
}
